import React from 'react';
import './Modal.css';

// title: título; headerExtra: nodo opcional bajo el título; contentClassName / overlayClassName: clases extra.
const Modal_proyectos = ({ isOpen, onClose, children, title, headerExtra, contentClassName, overlayClassName }) => {
    if (!isOpen) return null; // No renderizar si el modal no está abierto

    const overlayCls = ['modal-overlay', 'modal', overlayClassName].filter(Boolean).join(' ');
    const contentCls = ['modal-content2', contentClassName].filter(Boolean).join(' ');

    return (
        <div className={overlayCls} tabIndex="-1" role="dialog">
            <div className={contentCls}>
                {/* Header for title and close button */}
                <div className="modal-header">
                    <div className="modal-header-text">
                        <h2>{title}</h2>
                        {headerExtra ? <div className="modal-header-extra">{headerExtra}</div> : null}
                    </div>
                    <button type="button" className="close-button" onClick={onClose}>
                        &times;
                    </button>
                </div>
                {/* Body for the main content */}
                <div className="modal-body modal-dialog-scrollable">
                    {children} {/* The main content */}
                </div>
            </div>
        </div>
    );
};



export default Modal_proyectos;